/* DollarClothing - Guida taglie + "Calcola la mia taglia" - v1 - 3/11/2026 - EM-PARTNERS
   Bottone accanto alle taglie nella pagina prodotto, popup con tabella e calcolatore, in stile banconota DC.
   La tabella la sceglie lo script, il cliente non sceglie niente:
   - taglie a numero (42-56): jeans e pantaloni a numero, conta la vita;
   - taglie a lettere: dal nome del prodotto capisce se e' una maglia/felpa/giubbotto (conta il petto),
     un pantalone (conta la vita) o un completo/tuta (petto e vita).
   Si carica solo nelle pagine prodotto (riga in layout/theme.liquid). Nessuna dipendenza.
   Colori e font dai token di assets/dc-usa.css (con valori di riserva). */
(function () {
  if (window.__dcGT) return;
  window.__dcGT = 1;
  var VER = '1';
  var MAIL = 'dollarclothing2024@gmail.com';
  var HELP = '<a href="mailto:' + MAIL + '">scrivici</a> e ti aiutiamo a scegliere.';

  // Tabelle. Misure del corpo in cm. "max" = soglia della stima (sotto questo valore → questa taglia).
  var LET = [
    { s: 'S',   it: 46, chest: '88–94',   waist: '72–77', max: 94.5 },
    { s: 'M',   it: 48, chest: '95–100',  waist: '78–82', max: 100.5 },
    { s: 'L',   it: 50, chest: '101–106', waist: '83–87', max: 106.5 },
    { s: 'XL',  it: 52, chest: '107–112', waist: '88–92', max: 112.5 },
    { s: 'XXL', it: 54, chest: '113–118', waist: '93–97', max: Infinity }
  ];
  // Pantaloni con la taglia a lettere: conta la vita. "j" = la stessa vita nei jeans a numero.
  var BOT = [
    { s: 'S',   j: '44', waist: '72–77', max: 77.5 },
    { s: 'M',   j: '46', waist: '78–82', max: 82.5 },
    { s: 'L',   j: '48', waist: '83–87', max: 87.5 },
    { s: 'XL',  j: '50', waist: '88–92', max: 92.5 },
    { s: 'XXL', j: '52', waist: '93–97', max: Infinity }
  ];
  var NUM = [
    { s: '42', w: '27–28', waist: '68–72',   max: 72.5 },
    { s: '44', w: '29–30', waist: '73–77',   max: 77.5 },
    { s: '46', w: '31–32', waist: '78–82',   max: 82.5 },
    { s: '48', w: '33–34', waist: '83–87',   max: 87.5 },
    { s: '50', w: '35–36', waist: '88–92',   max: 92.5 },
    { s: '52', w: '37–38', waist: '93–97',   max: 97.5 },
    { s: '54', w: '39–40', waist: '98–102',  max: 102.5 },
    { s: '56', w: '41–42', waist: '103–107', max: Infinity }
  ];
  var LET_RE = /^(XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL)$/;
  var NUM_RE = /^\d{2}$/;
  var KEY = 'dcGtHW';

  // Che capo è: decide la tabella e su cosa si calcola la taglia.
  // Vince il primo nome di capo nel titolo ("GIUBBINO JEANS" = giubbino, "COORDINATO TUTA" = completo).
  // Materiali e forme (DENIM, CARGO, BAGGY...) contano solo se nel titolo non c'è un nome di capo.
  var RE_SET = /\b(COORD\w*|COMPLETO|COMPLETI|TRACKSUITE?|TUTA)\b/;
  var RE_BOT = /\b(PANTS?|PANTALON\w*|JOGGERS?|SHORTS?(?! ?SLEEVE)|BERMUDA|TROUSERS?|SWEATPANTS?|CHINOS?)\b/;
  var RE_TOP = /\b(T-?SHIRT|T SHIRT|TEE|SHIRT|MAGLI\w*|FELP\w*|HOODIE|HOODY|GIUBB\w*|GIACC\w*|JACKET|BOMBER|CAMICI\w*|POLO|GILET|VEST|SMANICATO|CAPPOTTO|PIUMINO|PUFFER|PARKA|WINDBREAKER|GIROCOLLO|GIROMANICA|CREWNECK|SWEATER|SWEATSHIRT|CANOTTA|TANK|OVERSHIRT|VARSITY|CARDIGAN|PULL|PULLOVER|LONG SLEEVE|LONGSLEEVE|BOXY)\b/;
  var RE_SHAPE = /\b(CARGO|BAGGY|BAL+O+N|CARPENTER|FLARED?|DENIM|JEANSE?|PARACHUTE|SKINNY)\b/;
  function catFromTitle(t, isNum) {
    if (isNum) return 'num';
    t = ' ' + String(t || '').toUpperCase().replace(/\s+/g, ' ') + ' ';
    if (/\bTUTA PANT/.test(t)) return 'bot'; // il pantalone della tuta
    var best = null, pos = Infinity, list = [['set', RE_SET], ['bot', RE_BOT], ['top', RE_TOP]];
    for (var i = 0; i < list.length; i++) {
      var at = t.search(list[i][1]);
      if (at >= 0 && at < pos) { pos = at; best = list[i][0]; }
    }
    if (best) return best;
    return RE_SHAPE.test(t) ? 'bot' : 'top';
  }
  window.__dcGTcat = catFromTitle;
  function productTitle() {
    var m = document.querySelector('meta[property="og:title"]');
    var t = m ? m.getAttribute('content') : '';
    if (!t) {
      var h = document.querySelector('product-info h1') || document.querySelector('h1');
      t = h ? h.textContent : '';
    }
    return t || '';
  }

  // Vestibilità del capo (facoltativa): metafield custom.fit_score (1 slim … 5 oversize), passato con data-fit.
  var FIT = (function () {
    var el = document.currentScript;
    if (!el || !el.hasAttribute('data-fit')) el = document.querySelector('script[data-fit]');
    var v = el ? parseInt(el.getAttribute('data-fit'), 10) : NaN;
    return v >= 1 && v <= 5 ? v : 0;
  })();
  var FIT_LAB = ['', 'slim', 'leggermente slim', 'in taglia', 'leggermente oversize', 'oversize'];

  // Stima da altezza (cm) e peso (kg). Petto per maglie e completi, vita per pantaloni e jeans.
  function pick(list, v) {
    for (var i = 0; i < list.length; i++) if (v < list[i].max) return i;
    return list.length - 1;
  }
  function calc(h, kg) {
    var chest = 74 + 0.62 * kg - 0.12 * h;
    var waist = 82.5 + 0.7 * kg - 0.3 * h;
    var li = pick(LET, chest), ni = pick(NUM, waist), bi = pick(BOT, waist);
    var minByH = h >= 195 ? 3 : (h >= 188 ? 2 : (h >= 181 ? 1 : 0)); // chi è alto non prende una maglia troppo corta
    var bumped = false;
    if (li < minByH) { li = minByH; bumped = true; }
    var lNear = null, nNear = null, bNear = null;
    if (!bumped) {
      if (li < LET.length - 1 && LET[li].max - chest <= 1.5) lNear = li + 1;
      else if (li > 0 && chest - LET[li - 1].max <= 1.5) lNear = li - 1;
    }
    if (ni < NUM.length - 1 && NUM[ni].max - waist <= 1) nNear = ni + 1;
    else if (ni > 0 && waist - NUM[ni - 1].max <= 1) nNear = ni - 1;
    if (bi < BOT.length - 1 && BOT[bi].max - waist <= 1) bNear = bi + 1;
    else if (bi > 0 && waist - BOT[bi - 1].max <= 1) bNear = bi - 1;
    return {
      li: li, ni: ni, bi: bi, lNear: lNear, nNear: nNear, bNear: bNear, bumped: bumped,
      lOut: chest < 86 ? 'low' : (chest > 120 ? 'high' : null),
      nOut: waist < 66 ? 'low' : (waist > 109 ? 'high' : null),
      bOut: waist < 70 ? 'low' : (waist > 99 ? 'high' : null)
    };
  }
  window.__dcGTcalc = calc;

  function la(s) { return 'la ' + s; }

  function letNote(r) {
    var a = LET[r.li].s;
    if (r.bumped) return 'Per la tua altezza ti consigliamo ' + la(a) + ', così non ti sta corta.';
    if (r.lOut === 'low') return 'Sei sotto la S: la S potrebbe starti un po’ larga.';
    if (r.lOut === 'high') return 'Sei oltre la XXL della tabella: ' + HELP;
    if (r.lNear === null) return '';
    var b = LET[r.lNear].s;
    return r.lNear > r.li
      ? 'Sei al limite tra ' + la(a) + ' e ' + la(b) + ': prendi ' + la(b) + ' se ti piace più comoda.'
      : 'Sei al limite tra ' + la(b) + ' e ' + la(a) + ': prendi ' + la(b) + ' se ti piace più aderente.';
  }
  function numNote(r) {
    var a = NUM[r.ni].s;
    if (r.nOut === 'low') return 'Sei sotto la 42: la 42 potrebbe starti un po’ larga in vita.';
    if (r.nOut === 'high') return 'Sei oltre la 56: ' + HELP;
    if (r.nNear === null) return '';
    var b = NUM[r.nNear].s;
    return r.nNear > r.ni
      ? 'Sei tra ' + la(a) + ' e ' + la(b) + ': se in vita ti piace più comodo, prendi ' + la(b) + '.'
      : 'Sei tra ' + la(b) + ' e ' + la(a) + ': se in vita ti piace più aderente, prendi ' + la(b) + '.';
  }
  function botNote(r) {
    var a = BOT[r.bi].s;
    if (r.bOut === 'low') return 'Sei sotto la S: la S potrebbe starti un po’ larga in vita.';
    if (r.bOut === 'high') return 'Sei oltre la XXL della tabella: ' + HELP;
    if (r.bNear === null) return '';
    var b = BOT[r.bNear].s;
    return r.bNear > r.bi
      ? 'Sei tra ' + la(a) + ' e ' + la(b) + ': se in vita ti piace più comodo, prendi ' + la(b) + '.'
      : 'Sei tra ' + la(b) + ' e ' + la(a) + ': se in vita ti piace più aderente, prendi ' + la(b) + '.';
  }

  // La taglia per questo capo: i = riga della tabella, near = taglia vicina (per il filtro con la vestibilità)
  function pickFor(c, r) {
    if (c === 'num') {
      return { i: r.ni, main: NUM[r.ni].s, sub: 'USA W' + NUM[r.ni].w, note: numNote(r), near: r.nNear, plain: r.nNear !== null && !r.nOut };
    }
    if (c === 'bot') {
      return { i: r.bi, main: BOT[r.bi].s, sub: 'Come la ' + BOT[r.bi].j + ' dei nostri jeans', note: botNote(r), near: r.bNear, plain: r.bNear !== null && !r.bOut };
    }
    if (c === 'set' && r.bOut === 'high') {
      var last = LET.length - 1;
      return { i: last, main: LET[last].s, sub: 'IT ' + LET[last].it, note: 'Sei oltre la XXL della tabella: ' + HELP, near: null, plain: false };
    }
    if (c === 'set' && r.bi > r.li) {
      // completo: la taglia deve andare bene anche per la vita del pantalone
      var s = LET[r.bi].s;
      return { i: r.bi, main: s, sub: 'IT ' + LET[r.bi].it, note: 'Nel completo conta anche la vita del pantalone: per questo ' + la(s) + ', anche se di petto potresti prendere una taglia più piccola.', near: null, plain: false };
    }
    return { i: r.li, main: LET[r.li].s, sub: 'IT ' + LET[r.li].it, note: letNote(r), near: r.lNear, plain: r.lNear !== null && !r.lOut && !r.bumped, bumped: r.bumped };
  }

  // Una tabella sola, quella del capo
  var TBL = {
    top: { h: 'Maglie, felpe e giubbini', cap: 'Misure del corpo in cm.', head: ['Taglia', 'IT', 'Petto', 'Vita'],
      rows: function () { return LET.map(function (r) { return [r.s, r.it, r.chest, r.waist]; }); }, note: '' },
    set: { h: 'Tute e coordinati', cap: 'Contano sia il petto che la vita. Misure del corpo in cm.', head: ['Taglia', 'IT', 'Petto', 'Vita'],
      rows: function () { return LET.map(function (r) { return [r.s, r.it, r.chest, r.waist]; }); }, note: '' },
    bot: { h: 'Pantaloni', cap: 'Conta la vita. Misura del corpo in cm.', head: ['Taglia', 'Vita', 'Jeans'],
      rows: function () { return BOT.map(function (r) { return [r.s, r.waist, r.j]; }); },
      note: 'Se nei nostri jeans a numero porti la 46, qui prendi la M.' },
    num: { h: 'Jeans e pantaloni a numero', cap: 'Conta la vita. Misura del corpo in cm.', head: ['Taglia', 'USA (W)', 'Vita'],
      rows: function () { return NUM.map(function (r) { return [r.s, r.w, r.waist]; }); },
      note: 'Nei jeans il numero è più basso di quello delle maglie: chi porta la M di solito prende la 46.' }
  };
  function tableHTML(c) {
    var t = TBL[c];
    var rows = t.rows().map(function (cells, i) {
      return '<tr data-i="' + i + '">' + cells.map(function (x) { return '<td>' + x + '</td>'; }).join('') + '</tr>';
    }).join('');
    var chest = c === 'top' || c === 'set';
    return '<p class="dc-gt__th">' + t.h + '</p><p class="dc-gt__cap">' + t.cap + '</p>' +
      '<table class="dc-gt__tbl"><caption class="dc-gt__sr">Taglie: ' + t.h + '</caption><thead><tr>' +
      t.head.map(function (x) { return '<th>' + x + '</th>'; }).join('') + '</tr></thead><tbody>' + rows + '</tbody></table>' +
      (t.note ? '<p class="dc-gt__note">' + t.note + '</p>' : '') +
      '<div class="dc-gt__how"><b>Come prendere le misure</b>' +
      (chest ? '<p>Petto: metro sotto le ascelle, nel punto più largo.</p>' : '') +
      '<p>Vita: dove allacci i pantaloni, senza stringere.</p></div>';
  }
  function fineText(c) {
    return 'È una stima fatta su altezza e peso. Se hai un fisico molto muscoloso o molto magro, guarda anche ' +
      (c === 'top' || c === 'set' ? 'petto e vita' : 'la vita') + ' nella tabella.';
  }

  // Cosa vuol dire la vestibilità per la taglia consigliata (la taglia non cambia: si avvisa il cliente)
  function fitNote(main, noDown) {
    if (!FIT) return '';
    var f = findGroup(), vals = f ? f.vals : [], i = vals.indexOf(main);
    var up = i >= 0 && i < vals.length - 1 ? vals[i + 1] : null;
    var down = i > 0 && !noDown ? vals[i - 1] : null;
    var c = 'Con ' + la(main) + ' ti starà ';
    if (FIT === 1) return c + 'aderente.' + (up ? ' Se lo vuoi più comodo prendi ' + la(up) + '.' : '');
    if (FIT === 2) return c + 'un po’ aderente.' + (up ? ' Se lo vuoi più comodo prendi ' + la(up) + '.' : '');
    if (FIT === 3) return c + 'come la tua taglia di sempre.';
    if (FIT === 4) return c + 'un po’ largo, com’è pensato.' + (down ? ' Se lo vuoi più aderente prendi ' + la(down) + '.' : '');
    return c + 'largo, com’è pensato.' + (down ? ' Se lo vuoi meno largo prendi ' + la(down) + '.' : '');
  }
  function fitBox(msg) {
    if (!FIT) return '';
    var bar = '';
    for (var i = 1; i <= 5; i++) bar += '<i' + (i === FIT ? ' class="is-on"' : '') + '></i>';
    return '<div class="dc-gt__fit"><p class="dc-gt__fit-t">Vestibilità di questo capo: <b>' + FIT_LAB[FIT] + '</b></p>' +
      '<div class="dc-gt__fit-bar" aria-hidden="true">' + bar + '</div>' +
      '<div class="dc-gt__fit-lab" aria-hidden="true"><span>Slim</span><span>In taglia</span><span>Oversize</span></div>' +
      (msg ? '<p class="dc-gt__fit-m">' + msg + '</p>' : '') + '</div>';
  }
  function fitTableNote() {
    if (FIT >= 4) return 'Le misure in tabella sono del corpo: prendi la tua taglia, questo capo veste già largo.';
    if (FIT && FIT <= 2) return 'Le misure in tabella sono del corpo: questo capo veste aderente, se sei al limite prendi la taglia più grande.';
    return '';
  }

  // Taglie del prodotto nella pagina
  function findGroup() {
    var scope = document.querySelector('product-info') || document;
    var groups = scope.querySelectorAll('.radio__buttons');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (g.closest('quick-add-product, cart-drawer, .drawer')) continue;
      var ins = g.querySelectorAll('input[type="radio"]');
      if (!ins.length) continue;
      var vals = [], isNum = true, isLet = true;
      for (var j = 0; j < ins.length; j++) {
        var v = String(ins[j].value).trim().toUpperCase();
        vals.push(v);
        if (!NUM_RE.test(v)) isNum = false;
        if (!LET_RE.test(v)) isLet = false;
      }
      if (isNum || isLet) return { g: g, ins: ins, vals: vals, kind: isNum ? 'num' : 'let' };
    }
    return null;
  }

  var ICON = '<svg class="dc-gt-ico" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M3 15.5 15.5 3 21 8.5 8.5 21z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M7 11.5l1.8 1.8M9.8 8.7l2.6 2.6M12.6 5.9l1.8 1.8M6.4 17.3 4.6 15.5M15.4 8.3l1.8 1.8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  // Stile DC: carta, inchiostro, verde banconota, angoli vivi, doppio filetto.
  var P = 'var(--dc-paper,#F2F0E6)', P2 = 'var(--dc-paper-2,#E8E5D8)', INK = 'var(--dc-ink,#0E120F)', INK2 = 'var(--dc-ink-2,#39403B)';
  var G = 'var(--dc-green,#1E5B3A)', GD = 'var(--dc-green-deep,#0F3423)', LINE = 'var(--dc-line,rgba(14,18,15,.16))';
  var SANS = 'var(--dc-sans,"Helvetica Neue",Arial,sans-serif)', SERIF = 'var(--dc-serif,"Times New Roman",serif)', MONO = 'var(--dc-mono,"Courier New",monospace)';
  var CAPS = 'font-family:' + SANS + ';font-stretch:78%;font-weight:700;text-transform:uppercase;';
  var CSS = [
    '.radio__fieldset.dc-gt-row{display:grid!important;grid-template-columns:minmax(0,1fr) auto;column-gap:10px;align-items:start}',
    '.radio__fieldset.dc-gt-row>legend{grid-column:1/-1;grid-row:1}',
    '.radio__fieldset.dc-gt-row>.radio__buttons{grid-column:1!important;grid-row:var(--dc-gt-r,1)!important}',
    '.radio__fieldset.dc-gt-row>.dc-gt-btn{grid-column:2;grid-row:var(--dc-gt-r,1);justify-self:end}',
    '.dc-gt-btn{display:inline-flex;align-items:center;gap:7px;height:40px;margin:0;padding:0 13px;border:1px solid ' + INK + ';border-radius:0;background:' + P2 + ';color:' + INK + ';' + CAPS + 'font-size:12px;line-height:1.05;letter-spacing:.09em;text-align:left;white-space:nowrap;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background-color .15s,color .15s}',
    '.dc-gt-btn .dc-gt-ico{flex:0 0 auto;color:' + G + ';transition:color .15s}',
    '.dc-gt-btn:hover{background:' + INK + ';color:' + P + '}',
    '.dc-gt-btn:hover .dc-gt-ico{color:currentColor}',
    '.dc-gt-btn:focus-visible{outline:2px solid ' + G + ';outline-offset:2px}',
    '.dc-gt-br{display:none}',
    '.dc-gt-btn--c{padding:0 11px;font-size:11px;line-height:1.05}',
    '.dc-gt-btn--c .dc-gt-br{display:inline}',
    '.dc-gt-btn--n{padding:0 7px;font-size:10px;letter-spacing:.04em}',
    '.radio__fieldset.dc-gt-row--n{column-gap:6px}',
    '.dc-gt-btn--n .dc-gt-ico{display:none}',
    'html.dc-gt-lock,html.dc-gt-lock body{overflow:hidden!important}',
    '.dc-gt[hidden]{display:none!important}',
    '.dc-gt{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483646;color:' + INK + ';font-family:' + SANS + ';-webkit-font-smoothing:antialiased}',
    '.dc-gt *{box-sizing:border-box}',
    '.dc-gt a{color:' + G + ';text-decoration:underline;text-underline-offset:2px}',
    '.dc-gt__ov{position:absolute;top:0;right:0;bottom:0;left:0;background:rgba(14,18,15,.62);opacity:0;transition:opacity .18s}',
    '.dc-gt__dlg{position:absolute;left:50%;top:50%;width:min(560px,calc(100vw - 32px));max-height:min(720px,84vh);max-height:min(720px,84dvh);display:flex;flex-direction:column;background:' + P + ';border-radius:0;box-shadow:0 0 0 1px ' + INK + ',0 0 0 5px ' + P + ',0 0 0 6px ' + INK + ',0 28px 70px rgba(0,0,0,.4);overflow:hidden;opacity:0;transform:translate(-50%,-48%) scale(.98);transition:opacity .18s,transform .18s}',
    '.dc-gt.is-open .dc-gt__ov{opacity:1}',
    '.dc-gt.is-open .dc-gt__dlg{opacity:1;transform:translate(-50%,-50%)}',
    '@media (prefers-reduced-motion:reduce){.dc-gt__ov,.dc-gt__dlg{transition:none}}',
    '.dc-gt__head{flex:0 0 auto;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 14px 15px 20px;background-color:' + GD + ';background-image:var(--dc-tex-light,none);color:' + P + '}',
    '.dc-gt__eye{display:block;margin:0 0 5px;font-family:' + MONO + ';font-size:10.5px;line-height:1;font-weight:500;letter-spacing:.16em;text-transform:uppercase;opacity:.72}',
    '.dc-gt .dc-gt__title{margin:0;font-family:' + SERIF + ';font-size:32px;line-height:.95;font-weight:400;letter-spacing:0;text-transform:none;color:inherit}',
    '.dc-gt__title em{font-style:italic}',
    '.dc-gt__x{flex:0 0 auto;width:40px;height:40px;display:grid;place-items:center;margin:0;padding:0;border:1px solid rgba(242,240,230,.45);border-radius:0;background:transparent;color:' + P + ';cursor:pointer;transition:background-color .15s,color .15s}',
    '.dc-gt__x:hover{background:' + P + ';color:' + GD + '}',
    '.dc-gt__tabs{flex:0 0 auto;display:grid;grid-template-columns:1fr 1fr;margin:16px 20px 0;border:1px solid ' + INK + '}',
    '.dc-gt__tab{height:40px;margin:0;padding:0 8px;border:0;border-radius:0;background:transparent;color:' + INK + ';' + CAPS + 'font-size:12px;letter-spacing:.08em;cursor:pointer;white-space:nowrap}',
    '.dc-gt__tab+.dc-gt__tab{border-left:1px solid ' + INK + '}',
    '.dc-gt__tab[aria-selected="true"]{background:' + INK + ';color:' + P + '}',
    '.dc-gt__body{overflow:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:16px 20px 22px}',
    '.dc-gt__th{margin:0 0 3px;' + CAPS + 'font-size:14px;line-height:1.25;letter-spacing:.06em}',
    '.dc-gt__cap{margin:0 0 10px;font-size:12px;line-height:1.45;color:' + INK2 + '}',
    '.dc-gt .dc-gt__tbl{width:100%;margin:0;border:0;border-collapse:separate;border-spacing:0;table-layout:auto;font-family:' + MONO + ';font-size:13px;line-height:1.2;font-variant-numeric:tabular-nums}',
    '.dc-gt .dc-gt__tbl th,.dc-gt .dc-gt__tbl td{padding:9px 8px;text-align:center;vertical-align:middle;line-height:1.2;background:none;border:0;border-bottom:1px solid ' + LINE + ';white-space:nowrap;color:inherit}',
    '.dc-gt .dc-gt__tbl th{' + CAPS + 'font-size:11px;letter-spacing:.09em;color:' + INK2 + ';border-bottom:3px double ' + INK + '}',
    '.dc-gt .dc-gt__tbl td:first-child,.dc-gt .dc-gt__tbl th:first-child{text-align:left;padding-left:10px}',
    '.dc-gt .dc-gt__tbl td:first-child{font-family:' + SANS + ';font-stretch:78%;font-weight:800;font-size:14px;letter-spacing:.04em}',
    '.dc-gt .dc-gt__tbl tr.is-hl td{background:' + G + ';color:' + P + ';border-bottom-color:' + G + '}',
    '.dc-gt__note{margin:12px 0 0;padding:10px 12px;border-left:3px solid ' + G + ';background:' + P2 + ';font-size:12px;line-height:1.45}',
    '.dc-gt__how{margin:16px 0 0;font-size:12px;line-height:1.5;color:' + INK2 + '}',
    '.dc-gt__how p{margin:2px 0 0}',
    '.dc-gt__how b{display:block;margin-bottom:2px;' + CAPS + 'font-size:12px;letter-spacing:.06em;color:' + INK + '}',
    '.dc-gt__link{display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;margin:16px 0 0;padding:12px 14px;border:1px solid ' + INK + ';border-radius:0;background:transparent;color:' + INK + ';' + CAPS + 'font-size:12px;line-height:1.3;letter-spacing:.06em;text-align:left;cursor:pointer;transition:background-color .15s,color .15s}',
    '.dc-gt__link:hover{background:' + INK + ';color:' + P + '}',
    '.dc-gt__lead{margin:0 0 14px;font-size:13px;line-height:1.5}',
    '.dc-gt__form{display:grid;grid-template-columns:1fr 1fr;gap:10px}',
    '.dc-gt__fld{display:block;margin:0;' + CAPS + 'font-size:12px;letter-spacing:.08em}',
    '.dc-gt__in{position:relative;display:block;margin-top:6px}',
    '.dc-gt__in input{display:block;width:100%;height:48px;margin:0;padding:0 44px 0 14px;border:1px solid rgba(14,18,15,.35);border-radius:0;background:#FBFAF5;color:' + INK + ';font-family:' + MONO + ';font-size:16px;font-weight:500;line-height:48px;letter-spacing:.02em;text-transform:none;-webkit-appearance:none;appearance:none;box-shadow:none}',
    '.dc-gt__in input:focus{outline:none;border-color:' + G + ';box-shadow:inset 0 0 0 1px ' + G + '}',
    '.dc-gt__in input[aria-invalid="true"]{border-color:#B3261E;box-shadow:inset 0 0 0 1px #B3261E}',
    '.dc-gt__u{position:absolute;right:14px;top:50%;transform:translateY(-50%);font-family:' + MONO + ';font-size:12px;font-weight:500;letter-spacing:.06em;text-transform:none;opacity:.6;pointer-events:none}',
    '.dc-gt__go{grid-column:1/-1;height:48px;margin:4px 0 0;padding:0 16px;border:0;border-radius:0;background:' + G + ';color:' + P + ';' + CAPS + 'font-size:13px;letter-spacing:.12em;cursor:pointer;transition:background-color .15s}',
    '.dc-gt__go:hover{background:' + GD + '}',
    '.dc-gt__err{grid-column:1/-1;margin:0;color:#B3261E;font-size:12px;font-weight:600}',
    '.dc-gt__res{margin:18px 0 0;padding:20px 18px;border:1px solid ' + INK + ';box-shadow:inset 0 0 0 4px ' + P2 + ',inset 0 0 0 5px ' + INK + ';background-color:' + P2 + ';background-image:var(--dc-tex-dark,none);text-align:center}',
    '.dc-gt__k{margin:0;font-family:' + MONO + ';font-size:11px;font-weight:500;letter-spacing:.14em;text-transform:uppercase;color:' + INK2 + '}',
    '.dc-gt__big{margin:6px 0 0;font-family:' + SERIF + ';font-size:66px;line-height:.9;font-weight:400;letter-spacing:0;color:' + GD + '}',
    '.dc-gt__sub{margin:8px 0 0;font-family:' + MONO + ';font-size:12px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;color:' + INK2 + '}',
    '.dc-gt__rn{margin:10px auto 0;max-width:420px;font-size:12.5px;line-height:1.45}',
    '.dc-gt__fit{margin:0 0 14px;padding:12px 12px 10px;border:1px solid ' + LINE + ';background:' + P2 + ';text-align:left}',
    '.dc-gt__res .dc-gt__fit{margin:14px 0 0;background:' + P + '}',
    '.dc-gt__fit-t{margin:0 0 8px;font-size:12px;line-height:1.35}',
    '.dc-gt__fit-t b{font-weight:700}',
    '.dc-gt__fit-bar{display:grid;grid-template-columns:repeat(5,1fr);gap:4px}',
    '.dc-gt__fit-bar i{display:block;height:4px;background:rgba(14,18,15,.15)}',
    '.dc-gt__fit-bar i.is-on{background:' + G + '}',
    '.dc-gt__fit-lab{display:flex;justify-content:space-between;margin-top:6px;font-family:' + MONO + ';font-size:10px;letter-spacing:.06em;text-transform:uppercase;opacity:.65}',
    '.dc-gt__fit-m{margin:10px 0 0;font-size:12.5px;line-height:1.45}',
    '.dc-gt__sel{display:inline-flex;align-items:center;justify-content:center;min-width:210px;height:46px;margin:16px 0 0;padding:0 22px;border:0;border-radius:0;background:' + INK + ';color:' + P + ';' + CAPS + 'font-size:13px;letter-spacing:.12em;cursor:pointer;transition:background-color .15s}',
    '.dc-gt__sel:hover{background:' + G + '}',
    '.dc-gt__oos{margin:8px 0 0;font-size:12px;line-height:1.45;color:#B3261E;font-weight:600}',
    '.dc-gt__fine{margin:14px 0 0;font-size:11px;line-height:1.45;color:' + INK2 + ';opacity:.8}',
    '.dc-gt__sr{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);border:0}',
    '@media (max-width:420px){.dc-gt__dlg{width:calc(100vw - 24px)}.dc-gt__head{padding:14px 12px 13px 16px}.dc-gt .dc-gt__title{font-size:28px}.dc-gt__tabs{margin:14px 16px 0}.dc-gt__body{padding:14px 16px 20px}.dc-gt__tab{font-size:11px;letter-spacing:.05em}.dc-gt .dc-gt__tbl th,.dc-gt .dc-gt__tbl td{padding:9px 5px}.dc-gt .dc-gt__tbl td:first-child,.dc-gt .dc-gt__tbl th:first-child{padding-left:8px}.dc-gt__big{font-size:58px}}'
  ].join('');

  var X_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square"/></svg>';

  var HTML =
    '<div class="dc-gt__ov" data-dc-close></div>' +
    '<div class="dc-gt__dlg" role="dialog" aria-modal="true" aria-labelledby="dc-gt-title">' +
      '<div class="dc-gt__head"><div><span class="dc-gt__eye" aria-hidden="true">DollarClothing · Taglie</span>' +
        '<h2 class="dc-gt__title" id="dc-gt-title">Guida <em>taglie</em></h2></div>' +
        '<button type="button" class="dc-gt__x" data-dc-close aria-label="Chiudi">' + X_ICON + '</button></div>' +
      '<div class="dc-gt__tabs" role="tablist">' +
        '<button type="button" class="dc-gt__tab" role="tab" id="dc-gt-t1" aria-controls="dc-gt-p1" aria-selected="true">Tabella taglie</button>' +
        '<button type="button" class="dc-gt__tab" role="tab" id="dc-gt-t2" aria-controls="dc-gt-p2" aria-selected="false" tabindex="-1">Calcola la mia taglia</button>' +
      '</div>' +
      '<div class="dc-gt__body">' +
        '<div class="dc-gt__panel" role="tabpanel" id="dc-gt-p1" aria-labelledby="dc-gt-t1">' +
          fitBox(fitTableNote()) +
          '<div class="dc-gt__tblwrap"></div>' +
          '<button type="button" class="dc-gt__link" data-dc-goto="2"><span>Non sai le misure? Calcola la taglia con altezza e peso</span><span aria-hidden="true">→</span></button>' +
        '</div>' +
        '<div class="dc-gt__panel" role="tabpanel" id="dc-gt-p2" aria-labelledby="dc-gt-t2" hidden>' +
          '<p class="dc-gt__lead">Inserisci altezza e peso: ti diciamo che taglia prendere per questo capo.</p>' +
          '<form class="dc-gt__form" novalidate>' +
            '<label class="dc-gt__fld">Altezza<span class="dc-gt__in"><input name="h" type="text" inputmode="numeric" autocomplete="off" maxlength="5" placeholder="es. 178"><span class="dc-gt__u">cm</span></span></label>' +
            '<label class="dc-gt__fld">Peso<span class="dc-gt__in"><input name="w" type="text" inputmode="decimal" autocomplete="off" maxlength="5" placeholder="es. 72"><span class="dc-gt__u">kg</span></span></label>' +
            '<p class="dc-gt__err" role="alert" hidden></p>' +
            '<button type="submit" class="dc-gt__go">Calcola la mia taglia</button>' +
          '</form>' +
          '<div class="dc-gt__res" aria-live="polite" hidden></div>' +
        '</div>' +
      '</div>' +
    '</div>';

  var root = null, lastFocus = null, cat = 'top', hideT = null;

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }

  function build() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'dc-gt';
    root.hidden = true;
    root.setAttribute('data-dc-v', VER);
    root.innerHTML = HTML;
    document.body.appendChild(root);

    $$('[data-dc-close]').forEach(function (b) { b.addEventListener('click', close); });
    $$('.dc-gt__tab').forEach(function (t, i) {
      t.addEventListener('click', function () { showTab(i + 1, true); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showTab(i === 0 ? 2 : 1, true); }
      });
    });
    $('[data-dc-goto]').addEventListener('click', function () { showTab(2, true); });
    $('.dc-gt__form').addEventListener('submit', function (e) { e.preventDefault(); run(true); });
    root.addEventListener('keydown', onKey);
  }

  function showTab(n, focus) {
    $$('.dc-gt__tab').forEach(function (t, i) {
      var on = i + 1 === n;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    $('#dc-gt-p1').hidden = n !== 1;
    $('#dc-gt-p2').hidden = n !== 2;
    $('.dc-gt__body').scrollTop = 0;
    if (n === 2 && focus) {
      var hIn = $('input[name="h"]');
      if (!hIn.value) setTimeout(function () { hIn.focus(); }, 30);
    }
  }

  function num(v) {
    v = String(v || '').replace(',', '.').replace(/[^\d.]/g, '');
    return v ? parseFloat(v) : NaN;
  }

  function sizeInput(val) {
    var f = findGroup();
    if (!f) return null;
    for (var i = 0; i < f.ins.length; i++) {
      if (String(f.ins[i].value).trim().toUpperCase() === val) return f.ins[i];
    }
    return null;
  }

  function run(fromSubmit) {
    var hIn = $('input[name="h"]'), wIn = $('input[name="w"]'), err = $('.dc-gt__err'), res = $('.dc-gt__res');
    var h = num(hIn.value), w = num(wIn.value);
    if (h > 0 && h < 3) h = h * 100; // 1,78 → 178
    var bad = [];
    if (!(h >= 140 && h <= 215)) bad.push('un’altezza tra 140 e 215 cm');
    if (!(w >= 40 && w <= 180)) bad.push('un peso tra 40 e 180 kg');
    hIn.setAttribute('aria-invalid', !(h >= 140 && h <= 215) ? 'true' : 'false');
    wIn.setAttribute('aria-invalid', !(w >= 40 && w <= 180) ? 'true' : 'false');
    if (bad.length) {
      if (fromSubmit) { err.textContent = 'Inserisci ' + bad.join(' e ') + '.'; err.hidden = false; }
      res.hidden = true;
      return;
    }
    err.hidden = true;
    try { localStorage.setItem(KEY, JSON.stringify({ h: Math.round(h), w: w })); } catch (e) {}
    var p = pickFor(cat, calc(h, w));
    var main = p.main, note = p.note;
    // la nota "al limite" non deve contraddire la vestibilità (capo oversize: niente "prendi la più grande")
    if (p.plain && ((FIT >= 4 && p.near > p.i) || (FIT && FIT <= 2 && p.near < p.i))) note = '';
    var inp = sizeInput(main);
    var html =
      '<p class="dc-gt__k">Per questo capo ti consigliamo</p>' +
      '<p class="dc-gt__big">' + main + '</p>' +
      '<p class="dc-gt__sub">' + p.sub + '</p>' +
      (note ? '<p class="dc-gt__rn">' + note + '</p>' : '') +
      fitBox(fitNote(main, p.bumped));
    if (inp) {
      html += '<button type="button" class="dc-gt__sel">Seleziona ' + la(main) + '</button>';
      if (inp.classList.contains('disabled') || inp.disabled) html += '<p class="dc-gt__oos">La ' + main + ' di questo capo ora è esaurita: selezionala e ti avvisiamo quando torna.</p>';
    } else if (findGroup()) {
      var f = findGroup();
      html += '<p class="dc-gt__oos">Questo capo non ha ' + la(main) + ': le taglie sono ' + f.vals.join(', ') + '.</p>';
    }
    html += '<p class="dc-gt__fine">' + fineText(cat) + '</p>';
    res.innerHTML = html;
    res.hidden = false;
    var sel = $('.dc-gt__sel', res);
    if (sel) sel.addEventListener('click', function () { choose(main); });
    $$('.dc-gt__tbl tr.is-hl').forEach(function (tr) { tr.classList.remove('is-hl'); });
    var tr = $('.dc-gt__tbl tr[data-i="' + p.i + '"]');
    if (tr) tr.classList.add('is-hl');
    if (fromSubmit && (hIn === document.activeElement || wIn === document.activeElement)) { try { document.activeElement.blur(); } catch (e) {} }
    if (fromSubmit) setTimeout(function () { res.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 30);
  }

  function choose(val) {
    var inp = sizeInput(val);
    close();
    if (!inp) return;
    var lab = inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null;
    if (!inp.checked) (lab || inp).click();
    try { inp.focus({ preventScroll: true }); } catch (e) {}
    var row = inp.closest('.selector-wrapper') || inp;
    var r = row.getBoundingClientRect();
    if (r.top < 70 || r.bottom > window.innerHeight - 20) row.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('button, input, a[href], [tabindex="0"]').filter(function (el) {
      return !el.disabled && el.offsetParent !== null && el.tabIndex !== -1;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(btn) {
    build();
    clearTimeout(hideT);
    lastFocus = btn || document.activeElement;
    var f = findGroup();
    cat = catFromTitle(productTitle(), !!(f && f.kind === 'num'));
    root.setAttribute('data-dc-cat', cat);
    $('.dc-gt__tblwrap').innerHTML = tableHTML(cat);
    showTab(1, false);
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (s && s.h && s.w) { $('input[name="h"]').value = s.h; $('input[name="w"]').value = String(s.w).replace('.', ','); run(false); }
    } catch (e) {}
    root.hidden = false;
    document.documentElement.classList.add('dc-gt-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    setTimeout(function () { var x = $('.dc-gt__x'); if (x) x.focus(); }, 60);
  }

  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('dc-gt-lock');
    clearTimeout(hideT);
    hideT = setTimeout(function () { root.hidden = true; }, 180);
    if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function inject() {
    var f = findGroup();
    if (!f) return;
    var fs = f.g.parentElement;
    if (!fs || fs.querySelector('.dc-gt-btn')) return;
    fs.classList.add('dc-gt-row');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dc-gt-btn';
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = ICON + '<span>Guida <br class="dc-gt-br">taglie</span>';
    b.addEventListener('click', function () { open(b); });
    var lg = fs.querySelector('legend');
    if (lg && lg.getBoundingClientRect().height > 0) fs.style.setProperty('--dc-gt-r', '2');
    fs.appendChild(b);
    fit(b);
  }

  // Il bottone sta sulla riga delle taglie: se le taglie andrebbero a capo, passa a due righe e poi senza icona.
  function fit(b) {
    var rb = b.parentElement && b.parentElement.querySelector('.radio__buttons');
    var pills = rb ? rb.querySelectorAll('.radio__button') : [];
    if (pills.length < 2) return;
    var first = pills[0], last = pills[pills.length - 1];
    var lv = ['dc-gt-btn', 'dc-gt-btn dc-gt-btn--c', 'dc-gt-btn dc-gt-btn--c dc-gt-btn--n'];
    for (var i = 0; i < lv.length; i++) {
      b.className = lv[i];
      b.parentElement.classList.toggle('dc-gt-row--n', i === 2);
      if (last.getBoundingClientRect().top <= first.getBoundingClientRect().top + 4) return;
    }
  }
  function refit() {
    var b = document.querySelector('.dc-gt-btn');
    if (b) fit(b);
  }

  function init() {
    if (!document.getElementById('dc-gt-css')) {
      var st = document.createElement('style');
      st.id = 'dc-gt-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    inject();
    var target = document.querySelector('product-info') || document.body;
    var t = null, rt = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; inject(); }, 40);
    }).observe(target, { childList: true, subtree: true });
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(refit, 150);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
